<div class="container-margin desktop-view">
  <div class="row">
    <span class="bold xx-large-font">Scores</span>
  </div>
  <div class="row margin-top-40">
    <span>Overall Sustainability Score</span>
  </div>
  <div class="row margin-top-10">
    <span class="xx-large-font">
      <span
        ><span class="bold">{{
          product.scores?.overallSustainabilityScore
        }}</span>
        / 100</span
      >
    </span>
  </div>
  <div class="margin-top-40">
    <mat-divider></mat-divider>
  </div>
  <div class="row margin-top-20">
    <span class="flex-basis-40">Net Zero Score</span>
    <span class="bold">{{ product.scores?.netZeroScore }}</span>
  </div>
  <div class="margin-top-20">
    <mat-divider></mat-divider>
  </div>
  <div class="row margin-top-20">
    <span class="flex-basis-40">Bio-Diversity Score</span>
    <span class="bold">{{ product.scores?.bioDiversityScore }}</span>
  </div>
  <div class="margin-top-20">
    <mat-divider></mat-divider>
  </div>
  <div class="row margin-top-20">
    <span class="flex-basis-40"
      >Modern Slavery (Forced and Child Labor) Score</span
    >
    <span class="bold">{{ product.scores?.modernSlaveryScore }}</span>
  </div>
  <div class="margin-top-20">
    <mat-divider></mat-divider>
  </div>
</div>

<div class="container mobile-view">
  <mat-toolbar class="row product-name-navbar">
    <span class="bold-600 medium-font">{{ product.name }}</span>
  </mat-toolbar>
  <div class="info-container-mobile">
    <div class="row margin-top-20">
      <span class="bold x-large-font">Scores</span>
    </div>
    <div class="row margin-top-20">
      <span>Overall Sustainability Score</span>
    </div>
    <div class="row margin-top-10">
      <span class="xx-large-font">
        <span
          ><span class="bold">{{
            product.scores?.overallSustainabilityScore
          }}</span>
          / 100</span
        >
      </span>
    </div>
    <div class="margin-top-20">
      <mat-divider></mat-divider>
    </div>
    <div class="row margin-top-10">
      <span>Net Zero Score</span>
    </div>
    <div class="row margin-top-5">
      <span>{{ product.scores?.netZeroScore }}</span>
    </div>
    <div class="margin-top-20">
      <mat-divider></mat-divider>
    </div>
    <div class="row margin-top-10">
      <span>Bio-Diversity Score</span>
    </div>
    <div class="row margin-top-5">
      <span class="bold">{{ product.scores?.bioDiversityScore }}</span>
    </div>
    <div class="margin-top-20">
      <mat-divider></mat-divider>
    </div>
    <div class="row margin-top-10">
      <span>Modern Slavery (Forced and Child Labor Score)</span>
    </div>
    <div class="row margin-top-5">
      <span class="bold">{{ product.scores?.modernSlaveryScore }}</span>
    </div>
    <div class="margin-top-20">
      <mat-divider></mat-divider>
    </div>
  </div>
</div>
